
/* injects from baggage-loader */

'use strict';

export default class ProjectManagerActivityController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		
	}

}
